export default {
    bindings: {
        guests: '=',
        staff: '<',
        loading: '=',
        customisations: '<'
    },
    controller: 'addGuestsController',
    template: require('../views/guests.add.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/guests.add.component.js